import CustomerCareLocaleKeys from '../../locales/keys';
import { i18n } from 'invision-core';
export function apFormHasErrors(ngFormError) {
  var errorList = [];
  if (ngFormError) {
    var errorTypes = Object.keys(ngFormError);
    errorTypes.forEach(function (errorType) {
      ngFormError[errorType].forEach(function (errDetail) {
        var fieldName = errDetail.$name;
        if (errorType === 'required') {
          errorList.push({
            description: i18n.translate(CustomerCareLocaleKeys.CREATE_CUSTOMER_FORM.ERRORS.IS_REQUIRED, {
              field: fieldName
            })
          });
        } else {
          errorList.push({
            description: i18n.translate(CustomerCareLocaleKeys.CREATE_CUSTOMER_FORM.ERRORS.IS_INVALID, {
              field: fieldName
            })
          });
        }
      });
    });
  }
  return errorList;
}